import { render, staticRenderFns } from "./cart-finished.vue?vue&type=template&id=06873f0c"
import script from "./cart-finished.vue?vue&type=script&lang=js"
export * from "./cart-finished.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports